import _ from 'lodash'
import * as supplierActions from '../actions'
import { Toast } from '@vzmi/shp_shared_compo'
import { createDebug } from '@vzmi/component_ec_nodejs_util/dist/node/debug'
import { HyperLink } from '../components/Common/Form'
import confUtil from '../../lib/confUtil'
import { saveIntoLocal } from '../lib/localStorageHelper'
const debug = createDebug('y:middlewares:reservice')

const saveFormContain = form => {
  if (_.isEmpty(form)) {
    return true // nothing to save, treat as success
  }

  const keys = Object.keys(form)
  if (keys.length >= 1) {
    const key = keys[0]
    const value = form[key].values || {}
    if (!_.isEmpty(value)) {
      saveIntoLocal(key, value)
      return true
    }
  }
  return false
}

const communicator = store => next => action => {
  if (action.error === true) {
    debug('reservice error action: %o', action)

    const errorCode = _.get(action, 'payload.errorData.error[0].code', '')
    const reduxState = store.getState()
    const {
      isSeller = false,
      envConf = {},
      user: {
        sellerId,
        simulated = false
      } = {}
    } = _.get(reduxState, 'page', {})
    const canUseDOM = !!(
      (typeof window !== 'undefined' &&
      window.document && window.document.createElement)
    )
    switch (errorCode) {
      case 40100000: // Missing or bad authentication while user login
      case 40100001: // Missing or bad authentication
      case 40100002: // Invalid cookie
      case 40100005: // Issue wssid failed
      case 40100006: // sdb cookie failed
      case 40100007: // se cookie failed
      case 40404000: { // User not found
        if (!isSeller || !canUseDOM) {
          break
        }

        const handleClick = () => {
          const simulatedUrl = sellerId
            ? confUtil.getAbsTemplateUrl(envConf)('sellerSimulateLoginWithId', { sellerId })
            : confUtil.getAbsUrl(envConf)('sellerSimulateLogin')
          const destination = simulated
            ? simulatedUrl
            : confUtil.getAbsUrl(envConf)('sellerLogin')
          const redirectAction = supplierActions.invokeRedirect({
            url: destination,
            timeout: 1000
          })

          store.dispatch(redirectAction)
        }

        Toast.error((
          <>
            登入逾時，請
            <HyperLink
              onClick={handleClick}
            >
              重新登入
            </HyperLink>
          </>
        ), { duration: 86400, messageId: 40100003 })
        break
      }
      case 40100003: {
        // client side 時需要手動觸發才會 redirect okta
        // server side 就發現 user okta 過期則自動導向
        const handleClick = () => {
          let dotDoneUrl = ''
          if (canUseDOM) {
            dotDoneUrl = window.location.href || ''

            const form = _.get(reduxState, 'form', {})
            if (!_.isEmpty(form)) {
              Toast.destroy()
              if (saveFormContain(form)) {
                Toast.info('資料暫存完成，準備更新Okta驗證')
              } else {
                Toast.error('資料暫存失敗')
                return // don't refresh Okta when saving data failure
              }
            }
          }

          if (isSeller) {
            const refreshPathname = confUtil.getAbsTemplateUrl(envConf)('sellerRefreshSeCookie', { sellerId })
            dotDoneUrl = sellerId ? refreshPathname : ''
          }

          const destination = confUtil.getTemplateUrl(
            'refreshOkta',
            { dotDoneUrl: encodeURIComponent(dotDoneUrl) }
          )

          const redirectAction = supplierActions.invokeRedirect({
            url: destination,
            timeout: 1000
          })

          store.dispatch(redirectAction)
        }

        if (canUseDOM) {
          Toast.error((
            <>
              Okta驗證逾時，請
              <HyperLink
                onClick={handleClick}
              >
                更新驗證資料
              </HyperLink>
              ?
            </>
          ), { duration: 86400, messageId: 40100003 })
        } else {
          // ssr auto redirect to refresh okta
          handleClick()
        }
        break
      }
      case 40100004: {
        const fetchWssidAction = isSeller
          ? supplierActions.fetchSeWssid
          : supplierActions.fetchWssid
        // When Check wssid failed, fetch wssid again
        if (canUseDOM) {
          Toast.error((
            <>
              連線逾時，是否
              <HyperLink
                onClick={() => {
                  store.dispatch(fetchWssidAction({ errorCode }))
                    .then(resultAction => {
                      Toast.destroy()
                      Toast.info('連線建立成功')
                    })
                }}
              >
                重新建立連線
              </HyperLink>
              ?
            </>
          ), { duration: 15 })
          break
        }

        break
      }
      default: {
        break
      }
    }
  }

  return next(action)
}

export default communicator
